export const card = {
  '&.MuiPaper-elevation1': {
    '&.MuiCard-root': {
      marginBottom: '16px',
      padding: '25px 16px',
    },
  },
} as const;

export const portalAdminPageContainerSx = {
  gap: 3,
  scrollMarginTop: '65px',
  justifyContent: 'stretch',
  width: '100%',
} as const;

export const portalAdminContentMaxWidth = '1560px';

export const portalAdminPageSectionSize = {
  xs: 12,
} as const;

export const portalAdminPanelSx = {
  padding: { xs: 1, sm: 2 },
  width: '100%',
  overflow: 'hidden',
} as const;

export const portalAdminPanelHeaderSx = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 2,
  mb: 2,
} as const;

export const portalAdminPanelTitleSx = {
  fontWeight: 700,
  lineHeight: 1.1,
} as const;

export const portalAdminPanelSubtitleSx = {
  color: 'text.subdued',
  display: 'block',
  mt: 0.75,
} as const;

export const portalAdminPanelEyebrowSx = {
  color: 'secondary.main',
  display: 'block',
  fontWeight: 700,
  mb: 0.75,
} as const;

export const portalAdminContentBandSx = {
  backgroundColor: 'grey.50',
  borderTop: 1,
  borderColor: 'divider',
  p: { xs: 1, sm: 1.5 },
  mx: { xs: -1, sm: -2 },
  mb: { xs: -1, sm: -2 },
  '& .MuiCard-root .MuiCardContent-root > .MuiGrid-container:first-of-type': {
    alignItems: 'flex-start',
  },
  '& .MuiCard-root .MuiCardContent-root > .MuiGrid-container:first-of-type .MuiTypography-h5, & .MuiCard-root .MuiCardContent-root > .MuiGrid-container:first-of-type .MuiTypography-h6':
    {
      fontSize: '1rem',
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: 1.3,
    },
} as const;
